import Spinner from 'react-bootstrap/Spinner'

const LoadingAnimation = ({ title = null }) => {

	return (
		<div className="d-flex justify-content-center" title={title ? title : "Now loading..."}>
			<Spinner className="mt-5 align-center" animation="border" role="status">
				<span className="visually-hidden">Loading...</span>
			</Spinner>
		</div>
	)
}
export default LoadingAnimation